import { render } from "./kaDianChangeDetail.vue?vue&type=template&id=1f5d47b9"
import script from "./kaDianChangeDetail.vue?vue&type=script&lang=js"
export * from "./kaDianChangeDetail.vue?vue&type=script&lang=js"

import "./kaDianChangeDetail.vue?vue&type=style&index=0&id=1f5d47b9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__